import { useAtomValue } from 'jotai'
import React from 'react'
import { match } from 'ts-pattern'

import { dialogInfoAtom } from '../atoms'

import { DeleteCustomerAttributeGroupDialog } from './DeleteCustomerAttributeGroupDialog'
import { EditCustomerAttributeGroupDialog } from './EditCustomerAttributeGroupDialog'
import { SortCustomerAttributeGroupDialog } from './SortCustomerAttributeGroupDialog'

export const Dialogs = () => {
  const dialogInfo = useAtomValue(dialogInfoAtom)

  return match(dialogInfo?.dialogType)
    .with(undefined, () => null)
    .with('create', 'update', () => <EditCustomerAttributeGroupDialog />)
    .with('delete', () => <DeleteCustomerAttributeGroupDialog />)
    .with('sort', () => <SortCustomerAttributeGroupDialog />)
    .exhaustive()
}
